import moment from 'moment';

const diffInMinutes = (dateA, dateB) => {
  return moment(dateA).diff(dateB, 'minute');
};

export default diffInMinutes;
